import script from "./tableContent.vue?vue&type=script&setup=true&lang=jsx"
export * from "./tableContent.vue?vue&type=script&setup=true&lang=jsx"

import "./tableContent.vue?vue&type=style&index=0&id=743b6620&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743b6620"]])

export default __exports__